import { RoutePath } from '../../routing/routes';
import { WizardFlowState } from './types';

const wizardFlowRoutesMap = new Map<WizardFlowState, RoutePath>([
  [WizardFlowState.ONBOARDING, RoutePath.ONBOARDING],
  [WizardFlowState.MEDIA_SOURCE, RoutePath.MEDIA_SOURCE],
  [WizardFlowState.MEDIA_IMPORT, RoutePath.MEDIA_IMPORT],
  [WizardFlowState.MEDIA_UPLOAD_AND_SELECT, RoutePath.MEDIA_PREVIEW],
  [WizardFlowState.CUSTOMIZE_THEME, RoutePath.CUSTOMIZE_VIDEO_THEME],
  [WizardFlowState.CUSTOMIZE_STYLE, RoutePath.CUSTOMIZE_VIDEO_STYLE],
  [WizardFlowState.CUSTOMIZE_MUSIC, RoutePath.CUSTOMIZE_VIDEO_MUSIC],
  [WizardFlowState.CUSTOMIZE_TEXTS, RoutePath.CUSTOMIZE_VIDEO_TEXT],
  [WizardFlowState.CUSTOMIZE_BUSINESS_INFO, RoutePath.BUSINESS_INFO],
  [WizardFlowState.VIDEO_PREVIEW_CREATING, RoutePath.VIDEO_CREATING],
  [WizardFlowState.VIDEO_PREVIEW, RoutePath.REVIEW_VIDEO],
  [WizardFlowState.OUTPUT, RoutePath.FINAL_PAGE],
]);

export default wizardFlowRoutesMap;
